module.exports = __webpack_public_path__ + "static/media/iconmonstr-product-3.9b021638.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/iconmonstr-product-3.svg
// module id = 716
// module chunks = 0